<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.63953 5.41883L5.77912 7.99999H5.75C3.95507 7.99999 2.5 9.45507 2.5 11.25C2.5 11.9532 2.72808 12.6374 3.15
      13.2L4.06822 14.4243L5.18342 19.6286C5.47983 21.0118 6.70222 22 8.11683 22H16.8832C18.2978 22 19.5202 21.0118
      19.8166 19.6286L20.9318 14.4243L21.85 13.2C22.2719 12.6374 22.5 11.9532 22.5 11.25C22.5 9.45507 21.0449 7.99999
      19.25 7.99999H19.2207L18.3603 5.41892C17.6798 3.37717 15.7691 1.99999 13.6169 2L11.3829 2.00001C9.23079 2.00002
      7.32012 3.37715 6.63953 5.41883ZM16.463 6.05135L17.1125 7.99999H7.88731L8.5369 6.0513C8.94524 4.82629 10.0916
      4.00001 11.3829 4.00001L13.6169 4C14.9082 4 16.0546 4.8263 16.463 6.05135ZM6.52426 9.99999C6.50813 10.0004 6.49196
      10.0004 6.47576 9.99999H5.75C5.05964 9.99999 4.5 10.5596 4.5 11.25C4.5 11.5205 4.58772 11.7836 4.75 12L5.8
      13.4C5.88682 13.5158 5.94748 13.649 5.9778 13.7905L7.13903 19.2095C7.23783 19.6706 7.64529 20 8.11683
      20H16.8832C17.3547 20 17.7622 19.6706 17.861 19.2095L19.0222 13.7905C19.0525 13.649 19.1132 13.5158 19.2
      13.4L20.25 12C20.4123 11.7836 20.5 11.5205 20.5 11.25C20.5 10.5596 19.9404 9.99999 19.25 9.99999H18.5259C18.5085
      10.0005 18.491 10.0005 18.4737 9.99999H6.52426Z"
      fill="currentColor"
    />
    <path
      d="M7.5 13C7.5 12.4477 7.94772 12 8.5 12H16.5C17.0523 12 17.5 12.4477 17.5 13C17.5 13.5523 17.0523 14 16.5
      14H8.5C7.94772 14 7.5 13.5523 7.5 13Z"
      fill="currentColor"
    />

    <path
      d="M9.5 17C9.5 16.4477 9.94772 16 10.5 16H14.5C15.0523 16 15.5 16.4477 15.5 17C15.5 17.5523 15.0523 18 14.5
      18H10.5C9.94772 18 9.5 17.5523 9.5 17Z"
      fill="currentColor"
    />
  </svg>
</template>
